import { StrictMode } from "react";
import { flushSync } from "react-dom";
import { createRoot, hydrateRoot } from "react-dom/client";
import { AppRoot } from "./AppRoot";
import { BuildBadge } from "./BuildBadge";
import { isStagingBuildHost } from "./build-info";
import { initializePlatform } from "./platform";
import "@fontsource/courier-prime/latin-400.css";
import "@fontsource/courier-prime/latin-400-italic.css";
import "@fontsource/courier-prime/latin-700.css";
import "@fontsource/courier-prime/latin-700-italic.css";
import "./styles.css";

void initializePlatform();

const root = document.getElementById("root")!;
const app = <AppRoot />;
const path = window.location.pathname.replace(/\/+$/, "") || "/";
const canHydrateHome = root.dataset.prerendered === "home" && path === "/";
const personalizedBoot = Boolean(window.__CRAFTOFF_BOOTSTRAP__ || window.__CRAFTOFF_PRESENTATION__);

function finishPersonalizedBoot(): void {
  delete document.documentElement.dataset.craftoffPersonalized;
  delete document.documentElement.dataset.craftoffWallpaper;
  delete document.documentElement.dataset.craftoffCustomWallpaper;
  document.documentElement.style.removeProperty("--craftoff-boot-wallpaper");
}

if (canHydrateHome && !personalizedBoot) hydrateRoot(root, app);
else {
  root.replaceChildren();
  const clientRoot = createRoot(root);
  if (personalizedBoot) {
    flushSync(() => clientRoot.render(app));
    finishPersonalizedBoot();
  } else clientRoot.render(app);
}

if (isStagingBuildHost(window.location.hostname)) {
  const badgeRoot = document.getElementById("staging-build-badge-root")!;
  createRoot(badgeRoot).render(
    <StrictMode>
      <BuildBadge />
    </StrictMode>
  );
}
